module.exports = __webpack_public_path__ + "img/logo-instagram.0edbbea9.svg";